export const ENTITIES_TYPES = {
  alarm: 'alarm',
  alarmDetails: 'alarmDetails',
  alarmDetailsSteps: 'alarmDetailsSteps',
  entity: 'entity',
  service: 'entityservices',
  weatherService: 'weatherService',
  pbehavior: 'pbehavior',
  event: 'event',
  userPreference: 'userPreference',
  snmpRule: 'snmpRule',
  testSuite: 'testSuite',
  testSuiteHistory: 'testSuiteHistory',
  linkRule: 'linkRule',
};
